import Client from "./Clients/AxiosClient";
const resource = "/api/v1/admin/irt";

export default {
    calibrate(paketMapelId) {
        return Client.post(`${resource}/calibrate/${paketMapelId}`);
    },
    getStatus(paketMapelId) {
        return Client.get(`${resource}/status/${paketMapelId}`);
    },
    getLatestRun(paketMapelId) {
        return Client.get(`${resource}/calibration-runs/latest/${paketMapelId}`);
    },
    getParameters(paketMapelId) {
        return Client.get(`${resource}/parameters/${paketMapelId}`);
    },
    exportParameters(paketMapelId) {
        return Client.get(`${resource}/parameters/${paketMapelId}/export`, {
            responseType: "blob",
        });
    },
    debugResponses(paketMapelId) {
        return Client.get(`${resource}/debug-responses/${paketMapelId}`);
    },
    debugSoal(paketMapelId, soalId) {
        return Client.get(`${resource}/debug-soal/${paketMapelId}/${soalId}`);
    },
    runFull(tryoutId) {
        return Client.post(`${resource}/run-full/${tryoutId}`);
    },
};
